import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import InputDate from 'modules/_shared/components/InputDate';
import InputText from 'modules/_shared/components/InputText';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import UploadDocument from 'modules/documents/components/UploadDocument';
import InputCheckbox from 'modules/_shared/components/InputCheckbox';

import { useInformationalModal } from '../context/InformationalModalContext';

const InformationalModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useInformationalModal();
  const animatedComponents = makeAnimated();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <InputText
          id="alias"
          label={t('OperationAlias')}
          value={data.alias}
          onChange={actions.handleChangeAlias}
          lgSize
        />

        <InputDate
          id="date"
          label={t('Date')}
          value={data.date || ''}
          onChange={actions.handleChangeDate}
          errorMessageKey="InvalidOperationDate"
          required
          lgSize
        />

        <div className="form-group">
          <label className="form-label" htmlFor="participants">
            {t('Participants')}
          </label>
          <div className="form-control-wrap">
            <Select
              id="participants"
              isMulti
              closeMenuOnSelect={false}
              className="react-select react-select-lg"
              options={data.participantOptions}
              value={data.selectedParticipants}
              components={animatedComponents}
              onChange={(options) =>
                actions.handleChangeParticipants(
                  (options as { value: string; label: string }[]) || []
                )
              }
              isDisabled={data.isForAllPartners}
              placeholder={t('SelectParticipants')}
            />
          </div>
        </div>

        <div className="form-group">
          <InputCheckbox
            id="selectAllPartners"
            label={t('SelectAllShareholders')}
            checked={data.isForAllPartners}
            onChange={actions.handleToggleForAllPartners}
          />
        </div>

        <UploadDocument
          label="AddDocumentOptional"
          inputLabel={data.file?.name || t('DragDocumentToUpload')}
          file={data.file}
          setFile={actions.handleChangeFile}
        />

        <InputTextArea
          id="comments"
          label={t('CommentsLabel')}
          value={data.comments}
          onChange={actions.handleChangeComments}
          noResize
        />
      </div>
    </Modal.Body>
  );
};

export default InformationalModalBody;
